<template>
  <div class="laboratoryManagement">
    <header>
      <div class="title">管理痛点</div>
      <ManagementPainPoints :list="MANAGE_LIST"></ManagementPainPoints>
    </header>
    <main>
      <div class="title">方案亮点</div>
      <IconLights :list="LIGHTS"></IconLights>
    </main>
    <section>
      <div class="title">方案优势</div>
      <Advantage :list="TECHNICAL_CAPACITY"></Advantage>
      <div class="title">业务过程</div>
      <div class="lc-title">整合资源建平台，智能预约严管控，数据驱动优共享</div>
      <div class="lc wow animate__animated animate__fadeIn">
        <div class="lc-left">
          <OssImg
            src="images/solution/resourceSharing/computer1.png"
            alt=""
          />
        </div>
        <div class="lc-right">
          <div class="lcList">
            <div class="lc-item maria" v-for="item in LC_LIST" :key="item.key">
              <div class="lc-img" :style="{ backgroundColor: item.color }">
                <OssImg :src="item.imgPath" />
              </div>
              <div style="flex: 1">
                <div class="lc-t">{{ item.text }}</div>
                <div class="lc-desc">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="wow animate__animated animate__fadeIn">
      <div class="title">硬件支持</div>
      <div class="device">
        <div class="d-t">
          <OssImg
            src="images/solution/resourceSharing/device1.png"
            alt=""
          />
          <div class="record">
            <div class="lc-img maria" :style="{ backgroundColor: '#e6f5ff' }">
              <OssImg
                src="images/solution/resourceSharing/device_icon1.png"
              />
            </div>
            <div style="flex: 1">
              <div class="lc-t">设备资产安全管控</div>
              <div class="lc-desc">
                搭配设备电源智能控制终端与监控，放置资产在非预约时段使用，保障设备资产安全与使用规范
              </div>
            </div>
          </div>
        </div>
        <div class="d-b">
          <div class="record">
            <div class="lc-img" :style="{ backgroundColor: '#efeeff' }">
              <OssImg
                src="images/solution/resourceSharing/device_icon2.png"
              />
            </div>
            <div style="flex: 1">
              <div class="lc-t">房间出入管控</div>
              <div class="lc-desc">
                仅允许预约成功且具备相应资质的人员进入实验室，杜绝非授权人员随意使用资源，保障设备资产安全，避免资源抢占或误操作风险。展示实验室资源预约状态、当前使用人员、剩余可用时段等信息，方便用户直观了解资源动态
              </div>
            </div>
          </div>
          <OssImg
            src="images/solution/resourceSharing/device2.png"
            alt=""
          />
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref,onMounted } from "vue";
import ManagementPainPoints from "./components/ManagementPainPoints.vue";
import IconLights from "./components/IconLights.vue";
import Advantage from "./components/Advantage.vue";
import { WOW } from 'wowjs'
const MANAGE_LIST = ref([
  {
    iconPath: "images/solution/resourceSharing/icon1.png",
    title: "信息孤岛现象严重",
    desc: "各实验室资源分散管理，缺乏统一平台公示设备、试剂、场地等信息，难获取准确共享资源清单，导致资源闲置与重复采购并存",
    key: 0,
  },
  {
    iconPath: "images/solution/resourceSharing/icon2.png",
    title: "预约管理混乱无序",
    desc: "依赖线下沟通或简单表格预约，易出现时间冲突、设备占用超时等问题，缺乏智能调度机制，资源使用效率低下",
    key: 1,
  },
  {
    iconPath: "images/solution/resourceSharing/icon3.png",
    title: "权责界定模糊不清",
    desc: "共享资源的使用权限、维护责任不明确，设备损坏后追责困难，试剂耗材消耗无记录，造成资源浪费与成本失控",
    key: 2,
  },
  {
    iconPath: "images/solution/resourceSharing/icon4.png",
    title: "激励机制缺失",
    desc: "资源提供方缺乏共享动力，使用方付费意愿低，缺少合理的成本分摊与利益分配模式，难以形成可持续的共享生态 ",
    key: 3,
  },
]);
const LIGHTS = ref([
  {
    desc: "采用 AI 算法优化预约规则，自动检测时间冲突，提供智能排期建议；支持设备占用超时预警与自动释放，结合电子门禁实现 “扫码即用”，大幅提升资源使用效率",
    imgPath: "images/solution/resourceSharing/light1.png",
    color: "#efeeff",
    key: 0,
  },
  {
    desc: "为共享资源配置唯一识别码，使用全程扫码登记，精准记录操作痕迹；通过区块链技术存证，明确设备损坏、耗材消耗责任归属，杜绝资源浪费与成本失控",
    imgPath: "images/solution/resourceSharing/light2.png",
    color: "#fffaee",
    key: 1,
  },
  {
    desc: "对接培训准入系统，确保使用者具备操作资质；在设备端安装传感器监测运行状态，场地部署环境监测设备，实时预警危化品交叉污染等风险，保障共享安全",
    imgPath: "images/solution/resourceSharing/light3.png",
    color: "#eef7ff",
    key: 2,
  },
]);

const TECHNICAL_CAPACITY = ref([
  {
    title: "多系统无缝集成",
    desc: "可与实验室信息管理系统（LIMS）、安防监控系统深度对接，实现考试数据、人员权限、安全监控信息互通，构建一体化安全管理生态，提升实验室整体运营效率",
    imgPath: "images/solution/resourceSharing/big_icon1.png",
    key: 0,
  },
  {
    title: "移动化便捷学习",
    desc: "配套移动端学习 APP，支持碎片化学习，人员可随时随地观看安全知识微课、参与模拟考试、接收培训提醒，打破时间与空间限制，提升学习灵活性",
    imgPath: "images/solution/resourceSharing/big_icon2.png",
    key: 1,
  },
  {
    title: "风险预警前置化",
    desc: "通过分析考试中暴露的高频错误操作、薄弱知识领域，提前预判实验室潜在安全风险，主动推送预防措施与改进建议，将安全隐患扼杀在萌芽阶段",
    imgPath: "images/solution/resourceSharing/big_icon3.png",
    key: 2,
  },
  {
    title: "人才梯队建设",
    desc: "根据考试成绩与能力评估，建立实验室人才安全能力档案，为人员晋升、评优提供参考依据，助力打造高素质、专业化的实验室安全人才梯队",
    imgPath: "images/solution/resourceSharing/big_icon4.png",
    key: 3,
  },
  {
    title: "国际标准兼容",
    desc: "考试内容与国际实验室安全标准（如 ISO 17025）接轨，满足跨国科研合作、国际认证等需求，提升实验室的国际化竞争力",
    imgPath: "images/solution/resourceSharing/big_icon5.png",
    key: 4,
  },
  {
    title: "社会资源联动",
    desc: "与消防、安监等外部机构合作，将专业救援人员的实战经验融入考试案例与培训内容，同时为人员提供与外部专家交流学习的机会，拓宽安全视野",
    imgPath: "images/solution/resourceSharing/big_icon6.png",
    key: 5,
  },
]);
const LC_LIST = ref([
  {
    imgPath: "images/solution/resourceSharing/control1.png",
    text: "使用前",
    desc: "通过统一平台整合全域资源，将设备、场地等信息数字化展示。用户依据需求在平台检索资源，系统结合 AI 算法智能匹配推荐，并提供灵活预约时段选项。预约时自动检测时间与空间冲突，确认后生成预约订单，同时关联准入资质审核，确保使用者具备操作资格",
    color: "#efeeff",
    key: 0,
  },
  {
    imgPath: "images/solution/resourceSharing/control2.png",
    text: "使用中",
    desc: "用户扫码开启资源使用权限，电子门禁与设备传感器同步启动，记录操作全程。设备运行状态、场地环境参数实时监测，若出现超时占用或异常操作，系统自动预警",
    color: "#eef7ff",
    key: 1,
  },
  {
    imgPath: "images/solution/resourceSharing/control3.png",
    text: "使用后",
    desc: "系统根据使用时长、耗材消耗等自动核算成本，按规则分摊费用。同时，对资源使用数据深度分析，生成可视化报表，展示资源使用趋势、效率等信息。基于数据结果，优化资源配置与共享策略，支持跨机构资源合作拓展",
    color: "#fffaee",
    key: 2,
  },
]);

onMounted(()=>{
  const wow = new WOW();
  wow.init();
})
</script>

<style lang="scss" scoped>
.laboratoryManagement {
  $titleSize: 60px;

  font-family: "PingFang SC";
  .title {
    color: rgba(33, 33, 33, 1);
    font-weight: 500;
    font-size: $titleSize;
    text-align: center;
  }
  main {
    margin: 56px 0px;
  }
  section {
    .lc-title {
      color: #424242;
      text-align: center;
      font-weight: 600;
      font-size: 32px;
      margin: 24px 0px 50px 0px;
    }
    .lc {
      display: flex;
      .lc-left {
      }
      .lc-right {
        margin-left: 32px;
        .lcList {
          display: flex;
          flex-direction: column;
          gap: 24px;
          .lc-item {
            box-sizing: border-box;
            padding: 16px;
            width: 100%;
            height: 150px;
            border-radius: 16px;
            background: #ffffff;
            display: flex;
            align-items: center;
            gap: 16px;
            .lc-img {
              width: 80px;
              border-radius: 80px;
              height: 80px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .lc-t {
              color: #424242;
              font-weight: 500;
              font-size: 16px;
              margin-bottom: 10px;
            }
            .lc-desc {
              color: #888888;
              font-weight: 500;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  footer {
    margin-top: 56px;
    .device {
      .d-t,
      .d-b {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .record {
          width: 50%;
          height: 146px;
          border-radius: 8px;
          background: hsl(0, 0%, 100%);
          box-sizing: border-box;
          padding: 16px;
          display: flex;
          align-items: center;
          gap: 16px;
          .lc-img {
            width: 80px;
            border-radius: 80px;
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .lc-t {
            color: #424242;
            font-weight: 500;
            font-size: 16px;
            margin-bottom: 10px;
          }
          .lc-desc {
            color: #888888;
            font-weight: 500;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
